import { getUserLogOut } from 'PrivateAPI';

export const logOutUser = async (error: any) => {
  window?.Sentry?.captureException?.(new Error(error), {
    level: 'info',
  });
  // TODO: Add toast notification callback telling user why they were signed out
  await getUserLogOut();
  window.location.href = '/';
};
